// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DiffOutlinedSvg from "@ant-design/icons-svg/es/asn/DiffOutlined";
import AntdIcon from '../components/AntdIcon';

var DiffOutlined = function DiffOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DiffOutlinedSvg
  }));
};

DiffOutlined.displayName = 'DiffOutlined';
export default React.forwardRef(DiffOutlined);